// extracted by mini-css-extract-plugin
export default {"container":"ResetPasswordPage_container__ajLr9","section_form":"ResetPasswordPage_section_form__Prup4","descript":"ResetPasswordPage_descript__KBlJl"};